import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/chart";
import { Area, CartesianGrid, ComposedChart, Line, XAxis, YAxis } from "recharts";

type RevenueOverviewChartData = {
  dateTime: string;
  trailingRevenue: number;
  month_year: string;
  revenue: number;
  query_period: string;
}[];

const chartConfig = {
  revenue: {
    label: "Revenue €",
    color: "hsl(var(--chart-1))",
  },

  trailingRevenue: {
    label: "Trailing Revenue €",
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig;

function RevenueOverviewChart({ chartData }: { chartData: RevenueOverviewChartData }) {
  return (
    <ChartContainer config={chartConfig}>
      <ComposedChart data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="dateTime" tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis
          dataKey="revenue"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value: number) => {
            return value.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              currency: "EUR",
              style: "currency",
              compactDisplay: "short",
              notation: "compact",
            });
          }}
        />
        <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
        <Line dataKey="revenue" type="linear" stroke="var(--color-revenue)" strokeWidth={2} dot={false} />
        <Area
          dataKey="trailingRevenue"
          type="monotone"
          fill="var(--color-trailingRevenue)"
          fillOpacity={0.2}
          stroke="var(--color-trailingRevenue)"
          strokeWidth={2}
          dot={false}
        />
        <ChartLegend content={<ChartLegendContent />} />
      </ComposedChart>
    </ChartContainer>
  );
}

export default RevenueOverviewChart;
